export interface Rights {
    canAccessUserManagement?: boolean;
    canAccessAccountManagement?: boolean;
    canAccessIntegrations?: boolean;
    canAccessPromptTemplates?: boolean;
    canAccessPublishPrompts?: boolean;
}

export const CAN_ACCESS_USER_MANAGEMENT = 'canAccessUserManagement';
export const CAN_ACCESS_ACCOUNT_MANAGEMENT = 'canAccessAccountManagement';
export const CAN_ACCESS_INTEGRATIONS = 'canAccessIntegrations';
export const CAN_ACCESS_PROMPT_TEMPLATES = 'canAccessPromptTemplates';
export const CAN_ACCESS_PUBLISH_PROMPTS = 'canAccessPublishPrompts';

export const hasActiveRights = (rights: Rights | undefined): rights is Rights =>
    !!rights && Object.values(rights).some(Boolean);
